import React from 'react';
import Footer from './components/Footer';
import Intro from './components/Intro';
import LoginEffects from './components/LoginEffects';

import styles from './index.module.scss';

export default function UserLayout(props) {
  return (
    <div className={styles.container}>
      <LoginEffects />
      <div className={styles.content}>
        <div className={styles.left}>
          <Intro />
        </div>
        <div className={styles.right}>
          <div className={styles.card}>
            {props.children}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
